import { Menu } from "antd";
import React, { Component } from "react";
import PropTypes from "prop-types";
import LeftMenuItem from "./LeftMenuItem";

const { SubMenu } = Menu;
class LeftSubMenu extends Component {
  constructor(props) {
    super(props);
  }

  renderContent() {
    const { item } = this.props;
    const submenus = item.submenus;
    const menuItems = [];
    for (let i = 0; i < submenus.length; i++) {
      const submenu = submenus[i];
      if (submenu.type === "menu" && submenu.submenus) {
        menuItems.push(<LeftSubMenu key={submenu.key} item={submenu} />);
      }

      if (submenu.type === "kpi") {
        menuItems.push(<LeftMenuItem key={submenu.key} item={submenu} />);
        //menuItems.push(<Menu.Item key={item.key}>{item.label}</Menu.Item>);
      }
    }

    return menuItems;
  }

  render() {
    const { item, ...others } = this.props;
    return (
      <SubMenu className="stats-title" key={item.key} title={item.label} {...others}>
        {this.renderContent()}
      </SubMenu>
    );
  }
}

LeftSubMenu.propTypes = {
  items: PropTypes.array
};

export default LeftSubMenu;



// WEBPACK FOOTER //
// src/modules/stats/components/LeftMenu/LeftSubMenu.js